import { render } from "./date-pickr.vue?vue&type=template&id=ba90b4c2"
import script from "./date-pickr.vue?vue&type=script&lang=js"
export * from "./date-pickr.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__